StickyHeader = window.StickyHeader ?= {}

#@import ShortcutHeader
#@export StickyHeader

ShortcutHeader = require './header'

_handleWindowResize = ->
  $purchaseCluster = $ '#purchase-cluster'

  $(window).on 'resize', ->
    $buyElement = $purchaseCluster.find '.buy.fixed'
    $buyElement.css left: $purchaseCluster?.offset()?.left

_getTargetsOnce = (shortcutMap) ->
  targets = {}
  for key, target of shortcutMap
    targets[key] = $ shortcutMap[key]

  targets

StickyHeader.init = ({header, stickyHeader}, done) ->
  {shortcutMap, watchElements, pageType, options} = header

  config = {
    stickyWatchElements: watchElements
    shortcutMap
  }

  $ ->
    $headerSticky = $('.header-row-sticky')

    if pageType is 'local'
      $carouselElem = $('.gallery, .gallery-single, .featured-image')
      carouselOffset = $carouselElem.offset()
      carouselHeight = $carouselElem.outerHeight()
      carouselBottomPosition = carouselHeight + carouselOffset.top

      StickyHeader.elements =
        pageType: pageType
        top: carouselBottomPosition
        headerSticky: $headerSticky

      if $(".multi-option-overlay-items").children().length
        $(".header-options a").click (e) ->
          e.preventDefault()
          $modal = $("#options")
          GIG.Modal.open(el: $modal)

    else if pageType is 'goods'
      $rowElem = $('.header-row')
      $writeUp = $('#deal-info')
      targets = _getTargetsOnce shortcutMap

      StickyHeader.elements =
        pageType: pageType
        row: $rowElem
        headerSticky: $headerSticky
        targets: targets
        watchElements: watchElements
        gap: 100
        shouldShowSticky: stickyHeader
        shouldShowQuicklinks: options.shouldShowQuicklinks
        shouldShowGoodsV2Sticky: options.shouldShowGoodsV2Sticky
        stickyTopV2SlideUpTime: options.stickyTopV2SlideUpTime
        stickyTopV2SlideDownTime: options.stickyTopV2SlideDownTime

      if $rowElem.length
        _.extend StickyHeader.elements,
          rowParent: $rowElem.parent()
          top: $rowElem.offset().top
          height: $rowElem.outerHeight()

      if $writeUp.length
        _.extend StickyHeader.elements,
          stickyTop: $writeUp.offset().top

    if options.shouldShowQuicklinks
      StickyHeader.quicklinks = $('#shorcuts-container li')
      StickyHeader.quicklinks.on 'click', (ev) ->
        StickyHeader.animateQuicklink($(this), ev)

    if stickyHeader
      $(window).scroll _.throttle StickyHeader.scrollAction, 20

    done()

StickyHeader.updateCssClass = (clicked) ->
  current = StickyHeader.quicklinks.filter '.selected'
  if clicked != current
    current.removeClass 'selected'
    clicked.addClass 'selected'

StickyHeader.animateQuicklink = (clicked, ev) ->
  {row, gap, shouldShowSticky, targets} = StickyHeader.elements
  current = StickyHeader.quicklinks.filter '.selected'
  if clicked != current
    target = targets[clicked.attr('id')]
    top = target.offset().top
    if shouldShowSticky
      top -= row.outerHeight()
      unless row.hasClass('header-row-sticked')
        top -= gap

    $('body,html').animate scrollTop: top, 500, -> StickyHeader.updateCssClass(clicked)
    ev?.preventDefault()

StickyHeader.scrollAction = ->
  {row, rowParent, headerSticky, targets, watchElements, gap, top, height, stickyTop, shouldShowQuicklinks, shouldShowGoodsV2Sticky, pageType, stickyTopV2SlideUpTime, stickyTopV2SlideDownTime} = StickyHeader.elements
  yPosition = $(window).scrollTop()

  if pageType is 'local'
    belowThreshold = yPosition > top
    if belowThreshold and not headerSticky.is(":animated")
      headerSticky.slideDown(280)
    else if not belowThreshold and headerSticky.is(":visible") and not headerSticky.is(":animated")
      headerSticky.slideUp(280)
  else if pageType is 'goods'
    if shouldShowGoodsV2Sticky
      belowThreshold = yPosition > stickyTop

      if belowThreshold
        headerSticky.stop().slideDown(stickyTopV2SlideDownTime)

        if shouldShowQuicklinks
          position = watchElements.length-1
          while position >= 0
            target = targets[watchElements[position]]
            targetTop = target?.offset()?.top
            if targetTop? and (yPosition + gap) >= targetTop
              break
            position--
          StickyHeader.updateCssClass StickyHeader.quicklinks.eq(position)
      else if not belowThreshold and headerSticky.is(":visible")
        headerSticky.stop().slideUp(stickyTopV2SlideUpTime)
    else
      if row.hasClass 'header-row-static'
        top = StickyHeader.elements.top = row.offset().top

      if yPosition > top
        row.removeClass 'header-row-static'
        row.addClass 'header-row-sticked'
        rowParent.css paddingTop: height

        if shouldShowQuicklinks
          position = watchElements.length-1
          while position >= 0
            target = targets[watchElements[position]]
            targetTop = target?.offset()?.top
            if targetTop? and (yPosition + gap) >= targetTop
              break
            position--
          StickyHeader.updateCssClass StickyHeader.quicklinks.eq(position)
      else
        row.removeClass 'header-row-sticked'
        row.addClass 'header-row-static'
        rowParent.css paddingTop: 0

module.exports = StickyHeader
